import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { Chips } from './Chips';
import { knowingSection } from '../data/salesCopy';
export function KnowingSection() {
  return <section className="bg-brand-taupe px-4 py-7 text-brand-ivory sm:py-9" data-id="element-133" data-mp="24arkwhvqcllm">
      <div className="mx-auto max-w-3xl" data-id="element-134" data-mp="1zd7vcltl0med">
        <SectionTitle light data-id="element-135" data-mp="1zc6l2jke43xp">⚠️ {knowingSection.heading}</SectionTitle>

        <p className="mt-4 text-center text-[13px] font-medium leading-snug text-brand-ivory/90 sm:text-[15px]" data-id="element-136" data-mp="1vc63wr5wpemy">
          {knowingSection.intro}
        </p>

        <div className="mt-3 flex justify-center" data-id="element-137" data-mp="1llb4el3ngijk">
          <Chips items={knowingSection.scattered} tone="light" data-id="element-138" data-mp="1lm3344sjmwe2" />
        </div>

        <p className="mt-3 text-center text-[13px] font-semibold leading-snug text-white sm:text-[15px]" data-id="element-139" data-mp="1gmzwifwx0i3z">
          {knowingSection.bridge}
        </p>

        <div className="mt-4 rounded-lg border border-brand-gold/50 bg-brand-sage/40 p-4" data-id="element-140" data-mp="1bp87btnnna3h">
          <p className="text-[13px] font-extrabold uppercase tracking-wide text-brand-gold sm:text-sm" data-id="element-141" data-mp="17nmweduol5vx">
            {knowingSection.systemLead}
          </p>
          <ul className="mt-2 grid gap-x-4 gap-y-1 sm:grid-cols-2" data-id="element-142" data-mp="3rzh4ynrydr1">
            {knowingSection.system.map(item => <li key={item} className="flex items-start gap-1.5 text-[12.5px] font-semibold leading-snug text-white sm:text-[13.5px]" data-id="element-143" data-mp="3l90j2uziwvkr">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-sand" aria-hidden="true" data-id="element-144" data-mp="hrqmyc450nty" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-4 space-y-1.5 text-center text-[13px] font-medium leading-snug text-brand-ivory/90 sm:text-[14.5px]" data-id="element-145" data-mp="8s3q83mcs678">
          {knowingSection.close.map(line => <p key={line} data-id="element-146" data-mp="2teosauviznxn">{line}</p>)}
        </div>
      </div>
    </section>;
}